

export const updateIndicativeOptionData = data => {
     return {
         type: 'UPDATE_OPTION_DATA',
         data
     }
}
